/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.22"
        height="95.44"
        viewBox="0 0 79.22 95.44"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M23.61 22.31h-7.55a1.25 1.25 0 0 0-1.26 1.25v21.86a1.25 1.25 0 0 0 1.25 1.25h7.55a1.25 1.25 0 0 0 1.25-1.25V23.56a1.25 1.25 0 0 0-1.24-1.25Zm-1.25 2.5v19.35h-5V24.81ZM43.38 22.31H35.8a1.25 1.25 0 0 0-1.25 1.25v21.86a1.25 1.25 0 0 0 1.25 1.25h7.55a1.25 1.25 0 0 0 1.25-1.23V23.56a1.25 1.25 0 0 0-1.23-1.25Zm-1.25 2.5v19.35h-5V24.81ZM63.16 22.31h-7.55a1.25 1.25 0 0 0-1.25 1.25v21.86a1.25 1.25 0 0 0 1.25 1.25h7.55a1.25 1.25 0 0 0 1.25-1.25V23.56a1.25 1.25 0 0 0-1.25-1.25Zm-1.25 2.5v19.35h-5V24.81Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M75.87 44.16H3.35A3.35 3.35 0 0 0 0 47.51v44.58a3.34 3.34 0 0 0 3.34 3.34h72.53a3.35 3.35 0 0 0 3.35-3.33V47.52a3.35 3.35 0 0 0-3.35-3.36Zm-72.52 2.5h72.52a.85.85 0 0 1 .85.85v44.58a.85.85 0 0 1-.84.84H3.35a.84.84 0 0 1-.85-.84V47.52a.85.85 0 0 1 .85-.85Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M19.91 1.1c-6 12-4.3 17.09 1.4 17.09S19.91 1.1 19.91 1.1"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m19 .65-.18.37-.36.74-.34.72-.32.68-.15.35-.3.69-.13.34-.27.66-.25.66c-.08.21-.15.43-.23.64l-.21.62c-.06.21-.13.41-.19.61l-.17.6c-.11.39-.21.77-.29 1.14l-.11.6a3.41 3.41 0 0 1-.1.54l-.09.52-.06.51c-.55 4.89 1.52 7.57 6.06 7.57 2 0 3-1.39 3.18-3.58a20 20 0 0 0-.77-6.2c-.29-1.16-.65-2.39-1-3.64s-.83-2.45-1.26-3.59l-.32-.82-.26-.64A1 1 0 0 0 19 .62Zm.8 3 .23.64c.25.69.49 1.41.72 2.13.4 1.22.74 2.4 1 3.51a18.57 18.57 0 0 1 .73 5.55c-.11 1.27-.47 1.75-1.19 1.75-3.75 0-5.14-2.65-3.56-8.21l.18-.58.09-.34.21-.62q.23-.63.48-1.29l.27-.68.3-.7c.1-.24.2-.48.31-.72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M39.68 1.1c-6 12-4.29 17.09 1.4 17.09S39.68 1.1 39.68 1.1"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m38.8.65-.37.74-.34.73-.33.72c-.06.12-.11.23-.16.35l-.3.7-.29.68-.26.66c0 .11-.09.22-.13.33l-.24.65-.11.32-.21.62-.19.61-.18.6c-1.94 7-.06 10.83 5.4 10.83 2 0 3-1.39 3.19-3.58a20.62 20.62 0 0 0-.78-6.2c-.29-1.16-.64-2.39-1-3.64s-.83-2.45-1.26-3.59l-.23-.56-.36-.9a1 1 0 0 0-1.28-.6 1 1 0 0 0-.57.53Zm.79 3 .23.64c.25.69.5 1.41.73 2.13.39 1.22.73 2.4 1 3.51a18.56 18.56 0 0 1 .72 5.55c-.1 1.27-.46 1.75-1.19 1.75-3.68 0-5.09-2.56-3.63-7.92l.17-.58a2.34 2.34 0 0 1 .18-.57l.21-.62c.07-.21.15-.42.23-.64l.25-.65a1.09 1.09 0 0 1 .13-.34l.28-.69.15-.35.32-.72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M59.46 1.1c-6 12-4.3 17.09 1.4 17.09S59.46 1.1 59.46 1.1"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m58.57.65-.19.37-.36.74c0 .12-.11.24-.17.36l-.33.72c0 .12-.1.23-.16.35l-.3.7-.28.68-.27.66c-.08.22-.17.44-.24.66l-.23.64c-.19.52-.35 1-.49 1.53l-.17.59a20.14 20.14 0 0 0-.63 3.45v.47c-.18 4.29 1.91 6.61 6.14 6.61 2 0 3-1.39 3.18-3.58a20 20 0 0 0-.77-6.2c-.29-1.16-.64-2.39-1-3.64-.32-1-.66-2-1-2.9l-.37-1-.21-.53-.26-.64a1 1 0 0 0-1.89 0Zm.79 3 .23.64c.25.69.49 1.41.73 2.13.39 1.22.73 2.4 1 3.51a18.89 18.89 0 0 1 .72 5.55c-.11 1.27-.47 1.75-1.19 1.75-3.43 0-4.88-2.21-3.9-6.83l.12-.54.15-.55.16-.58.19-.59.2-.62c.08-.21.15-.42.23-.64l.25-.65a1 1 0 0 1 .14-.34l.28-.69.15-.35.32-.72Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M45.72 65.1h3l.5.06h.25l.5.08h.26l.52.09h.26l.54.1.56.12.57.14.91.22 1 .26.68.19 1.08.32 1.16.35 1.25.38 1.82.58 2 .66 1.53.48 1 .29.92.28.89.25.85.23.82.22.39.1.78.19.75.17c.62.13 1.21.25 1.79.35l.69.11a29.69 29.69 0 0 0 4 .33h1v2.51a33.86 33.86 0 0 1-5.33-.36l-.73-.11c-.73-.12-1.48-.27-2.27-.45l-.79-.19-.84.06-.42-.11-.87-.23-.9-.25-.46-.14-.95-.28-1-.3-1.58-.5-3-1-.82-.19-1.2-.37-1.12-.34-.7-.21-1-.28-.93-.25-.86-.21-.55-.13-.53-.12-.51-.1-.5-.1-.48-.08h-.24l-.38-.13h-.23l-.46-.05H45.8c-3.13 0-5.48.93-9 3.45l-.64.46-.33.24-.68.52-.71.54-1.21 1c-4.94 3.85-7.86 5.37-11.91 5.37s-6.21-.78-9.8-2.91l-.63-.38c-3.5-2.12-5.5-2.88-9.12-2.93h-.41v-2.5c4.27 0 6.67.82 10.42 3l1 .61.73.42a13.61 13.61 0 0 0 7.8 2.15c2.86 0 5.13-1 8.6-3.5l.68-.51.72-.55 1.21-.94.77-.6.74-.56.36-.27.7-.51.67-.47c3.65-2.77 6.32-3.77 9.96-3.77Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'BirthdayCakeIcon';

export default Icon;
